import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import { isNull, isUndefined } from 'lodash';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import CustomCheckbox from '../../Common/CustomCheckbox';

const FctvaComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name }) =>
		onChange?.({ [name]: !data?.fctva }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					control={CustomCheckbox}
					indeterminate={
						isUndefined(data?.fctva) ? false : !!isNull(data?.fctva)
					}
					name="fctva"
					checked={data?.fctva ?? false}
					label="‎"
					libelle="Entre dans les dépenses aidées"
					onChange={handleChange}
					data-testid="fctvaCheckbox"
				/>
			</Form>
		</Panel>
	);
};

export default FctvaComponent;
